import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";

const {CHECKBOX, INPUT} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsFundus1: Array<any> = [
  {
    name: ["rightJsonValue", "FUNDUS", "Hoàng điểm"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hoàng điểm",
    checkbox: [
      {
        label: "Ánh hoàng điểm",
        value: "Ánh hoàng điểm",
        // span: 8,
      },
      {
        label: "Xuất tiết cứng",
        value: "Xuất tiết cứng",
        // span: 8,
      },
      {
        label: "Vi phình mạch",
        value: "Vi phình mạch",
        // span: 8,
      },
      {
        label: "Xuất huyết",
        value: "Xuất huyết",
        // span: 8,
      },
      {
        label: "Xuất huyết dưới võng mạc",
        value: "Xuất huyết dưới võng mạc",
        // span: 12,
      },
      {
        label: "Scar",
        value: "Scar",
        // span: 4,
      },
      {
        label: "Teo vùng võng mạc",
        value: "Teo vùng võng mạc",
        // span: 8,
      },
      // {
      //   label: "Biến đổi sắc tố",
      //   value: "Biến đổi sắc tố",
      // //   span: 8,
      // },
      {
        label: "Drusen",
        value: "Drusen",
        // span: 8,
      },
      {
        label: "Dịch dưới võng mạc",
        value: "Dịch dưới võng mạc",
        // span: 8,
      },
      {
        label: "Phù dạng nang",
        value: "Phù dạng nang",
        // span: 8,
      },
      {
        label: "Dày",
        value: "Dày",
        // span: 8,
      },
      {
        label: "Trắng",
        value: "Trắng",
        // span: 4,
      },
      {
        label: "Xuất tiết dạng bông",
        value: "Xuất tiết dạng bông",
        // span: 8,
      },
      {
        label: "Bong biểu mô sắc tố",
        value: "Bong biểu mô sắc tố",
        // span: 12,
      },
      {
        label: "Biến đổi ánh hoàng điểm",
        value: "Biến đổi ánh hoàng điểm",
        // span: 8,
      },

      {
        label: "Bất thường mạch máu",
        value: "Bất thường mạch máu",
        // span: 10,
      },
      {
        label: "Biến đổi sắc tố",
        value: "Biến đổi sắc tố",
        // span: 8,
      },
      {
        label: "Màng trước võng mạc",
        value: "Màng trước võng mạc",
        // span: 8,
      },
      {
        label: "Lỗ hoàng điểm",
        value: "Lỗ hoàng điểm",
        // span: 6,
      },
      {
        label: "Lỗ lớp hoàng điểm",
        value: "Lỗ lớp hoàng điểm",
        // span: 8,
      },

      {
        label: "Vạch màng ngăn trong",
        value: "Vạch màng ngăn trong",
        // span: 8,
      },
      {
        label: "Nốt trắng",
        value: "Nốt trắng",
        // span: 8,
      },
      {
        label: "Ánh vàng",
        value: "Ánh vàng",
        // span: 8,
      },
      {
        label: "Dấu hiệu Cherry đỏ",
        value: "Dấu hiệu Cherry đỏ",
        // span: 8,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "FUNDUS", "show"],
    hide: true,
  },
];

export const FieldsFundus2: Array<any> = [
  {
    name: ["leftJsonValue", "FUNDUS", "Hoàng điểm"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Hoàng điểm",
    checkbox: [
      {
        label: "Ánh hoàng điểm",
        value: "Ánh hoàng điểm",
        // span: 8,
      },
      {
        label: "Xuất tiết cứng",
        value: "Xuất tiết cứng",
        // span: 8,
      },
      {
        label: "Vi phình mạch",
        value: "Vi phình mạch",
        // span: 8,
      },
      {
        label: "Xuất huyết",
        value: "Xuất huyết",
        // span: 8,
      },
      {
        label: "Xuất huyết dưới võng mạc",
        value: "Xuất huyết dưới võng mạc",
        // span: 12,
      },
      {
        label: "Scar",
        value: "Scar",
        // span: 4,
      },
      {
        label: "Teo vùng võng mạc",
        value: "Teo vùng võng mạc",
        // span: 8,
      },
      // {
      //   label: "Biến đổi sắc tố",
      //   value: "Biến đổi sắc tố",
      // //   span: 8,
      // },
      {
        label: "Drusen",
        value: "Drusen",
        // span: 8,
      },
      {
        label: "Dịch dưới võng mạc",
        value: "Dịch dưới võng mạc",
        // span: 8,
      },
      {
        label: "Phù dạng nang",
        value: "Phù dạng nang",
        // span: 8,
      },
      {
        label: "Dày",
        value: "Dày",
        // span: 8,
      },
      {
        label: "Trắng",
        value: "Trắng",
        // span: 4,
      },
      {
        label: "Xuất tiết dạng bông",
        value: "Xuất tiết dạng bông",
        // span: 8,
      },
      {
        label: "Bong biểu mô sắc tố",
        value: "Bong biểu mô sắc tố",
        // span: 12,
      },
      {
        label: "Biến đổi ánh hoàng điểm",
        value: "Biến đổi ánh hoàng điểm",
        // span: 8,
      },

      {
        label: "Bất thường mạch máu",
        value: "Bất thường mạch máu",
        // span: 10,
      },
      {
        label: "Biến đổi sắc tố",
        value: "Biến đổi sắc tố",
        // span: 8,
      },
      {
        label: "Màng trước võng mạc",
        value: "Màng trước võng mạc",
        // span: 8,
      },
      {
        label: "Lỗ hoàng điểm",
        value: "Lỗ hoàng điểm",
        // span: 6,
      },
      {
        label: "Lỗ lớp hoàng điểm",
        value: "Lỗ lớp hoàng điểm",
        // span: 8,
      },

      {
        label: "Vạch màng ngăn trong",
        value: "Vạch màng ngăn trong",
        // span: 8,
      },
      {
        label: "Nốt trắng",
        value: "Nốt trắng",
        // span: 8,
      },
      {
        label: "Ánh vàng",
        value: "Ánh vàng",
        // span: 8,
      },
      {
        label: "Dấu hiệu Cherry đỏ",
        value: "Dấu hiệu Cherry đỏ",
        // span: 8,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "FUNDUS", "show"],
    hide: true,
  },
];
const listMedia = [
  {value: "Rõ", label: "Rõ"},
  {value: "Mờ", label: "Mờ"},
];
const listPVD = [
  {value: "Không", label: "Không"},
  {value: "Có", label: "Có"},
];
const listOptic = [
  {value: "Nhỏ", label: "Nhỏ"},
  {value: "Trung bình", label: "Trung bình"},
  {value: "Lớn", label: "Lớn"},
];
const listCup = [
  {value: "0.1", label: "0.1"},
  {value: "0.15", label: "0.15"},
  {value: "0.2", label: "0.2"},
  {value: "0.25", label: "0.25"},
  {value: "0.3", label: "0.3"},
  {value: "0.35", label: "0.35"},
  {value: "0.4", label: "0.4"},
  {value: "0.45", label: "0.45"},
  {value: "0.5", label: "0.5"},
  {value: "0.55", label: "0.55"},
  {value: "0.6", label: "0.6"},
  {value: "0.7", label: "0.7"},
  {value: "0.75", label: "0.75"},
  {value: "0.8", label: "0.8"},
  {value: "0.85", label: "0.85"},
  {value: "0.9", label: "0.9"},
];
const listVitreous = [
  {value: "Rõ", label: "Rõ"},
  {value: "Tế bào", label: "Tế bào"},
  {value: "Mờ", label: "Mờ"},
  {value: "Xuất tiết", label: "Xuất tiết"},
  {value: "Hoạt động", label: "Hoạt động"},
  {value: "Bất hoạt", label: "Bất hoạt"},
  {value: "Xuất tiết vùng Pars Plana", label: "Xuất tiết vùng Pars Plana"},
  {value: "Bóng tuyết", label: "Bóng tuyết"},
  {value: "Xuất huyết mới", label: "Xuất huyết mới"},
  {value: "Xuất huyết cũ", label: "Xuất huyết cũ"},
  {value: "Dải dịch kính", label: "Dải dịch kính"},

  {value: "Khoảng trống dịch kính", label: "Khoảng trống dịch kính"},
  {value: "Thoái hóa dịch kính", label: "Thoái hóa dịch kính"},
  {value: "Vẩn đục dịch kính", label: "Vẩn đục dịch kính"},
  {value: "Ngưng tụ dịch kính", label: "Ngưng tụ dịch kính"},
  {
    value: "Bong dịch kính sau",
    label: "Bong dịch kính sau",
  },
  {value: "Vòng Weiss", label: "Vòng Weiss"},
  {value: "Xuất huyết sau dịch kính", label: "Xuất huyết sau dịch kính"},
  {value: "Silicone", label: "Silicone"},
];
const listRetinal = [
  {value: "Một phần", label: "Một phần"},
  {value: "Hầu hết", label: " Hầu hết"},
  {value: "Toàn bộ", label: "Toàn bộ"},
  {value: "Kín đáo", label: "Kín đáo"},
  {value: "Có lỗ rách", label: "Có lỗ rách"},
  {value: "Xuất tiết", label: "Xuất tiết"},
  {value: "Co kéo", label: "Co kéo"},
  {value: "Kết hợp", label: "Kết hợp"},
  {value: "Nhiều lỗ rách", label: "Nhiều lỗ rách"},
];
const listFundus = [
  {value: "Thoái hóa hàng rào", label: "Thoái hóa hàng rào"},
  {value: "Lỗ rách mạn tính", label: "Lỗ rách mạn tính"},

  {value: "Lỗ rách hình móng ngựa", label: "Lỗ rách hình móng ngựa"},
  {value: "Lỗ rách có nắp", label: "Lỗ rách có nắp"},
  {value: "Dialysis", label: "Dialysis"},

  {value: "Lỗ rách lớn", label: "Lỗ rách lớn"},
  {value: "Nhiều", label: "Nhiều"},
  {value: "Nhiều lỗ rách", label: "Nhiều lỗ rách"},

  {
    value: "Vùng trắng ko ấn",
    label: "Vùng trắng ko ấn",
  },
];
export {
  listCup,
  listFundus,
  listMedia,
  listOptic,
  listVitreous,
  listPVD,
  listRetinal,
};
